// extracted by mini-css-extract-plugin
module.exports = {"otpBanner":"styles_otpBanner__d1O6N"};